var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getMsOrgApiBaseUrl, readViteEnv, resolveApplicationId, } from "./wecomMsOrgApi";
var OAUTH_ATTEMPT_KEY = "wecom_oauth_attempt";
/** 发起企微 OAuth 前写入 `pathname+search`，换票成功后回到该路径（避免各菜单都落到同一 fallback） */
var WECOM_OAUTH_RETURN_PATH_KEY = "wecom_oauth_return_path";
/** 企微换票失败时写入，避免 Guard 再次跳转 OAuth 死循环 */
export var WECOM_OAUTH_FAIL_KEY = "wecom_oauth_fail";
export function setWecomOAuthFail(message, code, ttlMs) {
    if (ttlMs === void 0) { ttlMs = 120000; }
    try {
        var payload = __assign({ message: message.trim() || "企微登录失败", until: Date.now() + ttlMs }, (code ? { code: code } : {}));
        sessionStorage.setItem(WECOM_OAUTH_FAIL_KEY, JSON.stringify(payload));
    }
    catch (_a) {
        // ignore
    }
}
export function readWecomOAuthFail() {
    try {
        var raw = sessionStorage.getItem(WECOM_OAUTH_FAIL_KEY);
        if (!raw)
            return null;
        var p = JSON.parse(raw);
        if (!(p === null || p === void 0 ? void 0 : p.message) || typeof p.until !== "number")
            return null;
        if (Date.now() > p.until) {
            sessionStorage.removeItem(WECOM_OAUTH_FAIL_KEY);
            return null;
        }
        return p;
    }
    catch (_a) {
        return null;
    }
}
export function clearWecomOAuthFail() {
    try {
        sessionStorage.removeItem(WECOM_OAUTH_FAIL_KEY);
    }
    catch (_a) {
        // ignore
    }
}
export function isLikelyWeComWebView() {
    try {
        var ua = navigator.userAgent || "";
        return /wxwork|wxworklocal|wechatwork|WeChatWork|Wework|wework/i.test(ua);
    }
    catch (_a) {
        return false;
    }
}
export function getWecomCallbackUrl(options) {
    var _a, _b, _c;
    var fromOpts = (_a = options === null || options === void 0 ? void 0 : options.wecomRedirectUri) === null || _a === void 0 ? void 0 : _a.trim();
    var fromEnv = (typeof process !== "undefined" && ((_c = (_b = process.env) === null || _b === void 0 ? void 0 : _b.REACT_APP_WECOM_OAUTH_REDIRECT_URI) === null || _c === void 0 ? void 0 : _c.trim())) ||
        readViteEnv("VITE_WECOM_OAUTH_REDIRECT_URI");
    if (fromOpts)
        return fromOpts;
    if (fromEnv)
        return fromEnv;
    return "".concat(window.location.origin, "/wecom-callback");
}
/**
 * 与 {@link buildWecomAuthorizeUrl} 相同数据源，失败时带回 msOrg 的 message/code（便于排障）。
 * 依赖：msOrg `GET …/public/wecom-oauth-client/:applicationId`（库中 `applications.wecomAgentId` + 环境变量 `WECOM_CORP_ID`）。
 */
export function buildWecomAuthorizeUrlResult(options) {
    var _a, _b;
    return __awaiter(this, void 0, Promise, function () {
        var appId, base, url, res, e_1, msg, data, _c, msg, msg, corpId, agentId, prefix, state, params, href;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    appId = resolveApplicationId(options);
                    if (!appId) {
                        return [2 /*return*/, {
                                ok: false,
                                reason: "未配置 applicationId（需在构建时注入 VITE_MSORG_APPLICATION_ID 或 REACT_APP_MSORG_APPLICATION_ID）",
                                code: "MISSING_APPLICATION_ID",
                            }];
                    }
                    base = getMsOrgApiBaseUrl(options);
                    url = "".concat(base, "/public/wecom-oauth-client/").concat(encodeURIComponent(appId));
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(url, { method: "GET", credentials: "omit" })];
                case 2:
                    res = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    msg = e_1 instanceof Error ? e_1.message : "未知错误";
                    return [2 /*return*/, { ok: false, reason: "\u8BF7\u6C42 msOrg \u5931\u8D25\uFF1A".concat(msg), code: "FETCH_FAILED" }];
                case 4:
                    _d.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, res.json()];
                case 5:
                    data = (_d.sent());
                    return [3 /*break*/, 7];
                case 6:
                    _c = _d.sent();
                    return [2 /*return*/, {
                            ok: false,
                            reason: res.ok ? "msOrg 返回体不是合法 JSON" : "msOrg \u8FD4\u56DE\u975E JSON\uFF08HTTP ".concat(res.status, "\uFF09"),
                            httpStatus: res.status,
                        }];
                case 7:
                    if (!res.ok) {
                        msg = typeof data.message === "string" && data.message.trim()
                            ? data.message.trim()
                            : "HTTP ".concat(res.status);
                        return [2 /*return*/, {
                                ok: false,
                                reason: msg,
                                httpStatus: res.status,
                                code: typeof data.code === "string" ? data.code : undefined,
                            }];
                    }
                    if (!data.success || !((_a = data.corpId) === null || _a === void 0 ? void 0 : _a.trim()) || !((_b = data.agentId) === null || _b === void 0 ? void 0 : _b.trim())) {
                        msg = typeof data.message === "string" && data.message.trim()
                            ? data.message.trim()
                            : "响应中缺少 success 或 corpId/agentId";
                        return [2 /*return*/, {
                                ok: false,
                                reason: msg,
                                httpStatus: res.status,
                                code: typeof data.code === "string" ? data.code : undefined,
                            }];
                    }
                    corpId = data.corpId.trim();
                    agentId = data.agentId.trim();
                    prefix = ((options === null || options === void 0 ? void 0 : options.oauthStatePrefix) || "msapp").replace(/[^a-zA-Z0-9_-]/g, "") || "msapp";
                    state = "".concat(prefix, "_").concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 8));
                    params = new URLSearchParams({
                        appid: corpId,
                        redirect_uri: getWecomCallbackUrl(options),
                        response_type: "code",
                        scope: "snsapi_base",
                        state: state,
                        agentid: agentId,
                    });
                    href = "https://open.weixin.qq.com/connect/oauth2/authorize?".concat(params.toString(), "#wechat_redirect");
                    return [2 /*return*/, { ok: true, url: href }];
            }
        });
    });
}
/**
 * 从 msOrg 拉 corpId + agentId（applications.wecomAgentId），拼企微 OAuth URL。
 */
export function buildWecomAuthorizeUrl(options) {
    return __awaiter(this, void 0, Promise, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, buildWecomAuthorizeUrlResult(options)];
                case 1:
                    r = _a.sent();
                    return [2 /*return*/, r.ok ? r.url : null];
            }
        });
    });
}
export function clearOauthAttemptFlag() {
    try {
        sessionStorage.removeItem(OAUTH_ATTEMPT_KEY);
    }
    catch (_a) {
        // ignore
    }
}
/** 在跳转企微授权页面前调用：记录当前 SPA 路径，供 {@link takeWecomOauthReturnPathOrFallback} 使用 */
export function rememberPathBeforeWecomOAuthRedirect() {
    try {
        var path = window.location.pathname + window.location.search;
        if (!path || path.startsWith("/wecom-callback"))
            return;
        sessionStorage.setItem(WECOM_OAUTH_RETURN_PATH_KEY, path);
    }
    catch (_a) {
        // ignore
    }
}
export function clearWecomOauthReturnPath() {
    try {
        sessionStorage.removeItem(WECOM_OAUTH_RETURN_PATH_KEY);
    }
    catch (_a) {
        // ignore
    }
}
/**
 * 换票成功后调用：取出并清除记录；仅允许站内相对路径，否则用 fallback。
 */
export function takeWecomOauthReturnPathOrFallback(fallback) {
    var _a;
    try {
        var raw = sessionStorage.getItem(WECOM_OAUTH_RETURN_PATH_KEY);
        sessionStorage.removeItem(WECOM_OAUTH_RETURN_PATH_KEY);
        if (!raw || typeof raw !== "string")
            return fallback;
        var t = raw.trim();
        if (!t.startsWith("/") || t.startsWith("//"))
            return fallback;
        if (t.includes("..") || t.toLowerCase().includes("%2e%2e"))
            return fallback;
        var beforeHash = ((_a = t.split("#")[0]) !== null && _a !== void 0 ? _a : t).trim();
        if (!beforeHash || beforeHash.includes(":"))
            return fallback;
        return beforeHash;
    }
    catch (_b) {
        return fallback;
    }
}
